<template>
  <el-container>
    <!--左侧导航栏-->
    <el-aside style="width: 260px;overflow: hidden;">
      <div class="asideContainer">
        <div class="asideList">
          <template v-for="(item, index) in plateList">
            <router-link v-if="item.canSee" class="aCoverDiv" :to="{ name: item.link }" :key="'plateList' + index">
              <div class="asideItem">
                <div class="titleIcon">
                  <img :src="item.iconSrc" height="24px" />
                </div>
                <div class="titleText">
                  {{ item.name }}
                </div>
              </div>
            </router-link>
          </template>

          <!--分隔线-->
          <!--<div style="background-color: #617799;height: 0.05rem;"></div>-->

          <!--<div style="font-size: 20px;font-weight: bold;margin: 15px 0 15px 20px;cursor: default;">应用软件分类</div>-->
          <!--<router-link class="aCoverDiv" :to="{path: item.link}" v-for="(item, index) in plateAppList" :key="'plateAppList'+index">-->
          <!--  <div  class="asideItem">-->
          <!--    <div class="titleIcon">-->
          <!--      <img :src="item.iconSrc" height="24px" />-->
          <!--    </div>-->
          <!--    <div class="titleText">{{item.name}}</div>-->
          <!--  </div>-->
          <!--</router-link>-->
        </div>
      </div>
    </el-aside>
    <!--右侧内容，子路由跳转-->
    <el-main style="padding: 12px 12px 12px 0!important;overflow: visible;">
      <router-view></router-view>
    </el-main>
  </el-container>
</template>

<script>
import { selectApplystypeList } from '../../../api/appStore/appCommon'
import { hasAuthority } from "../../../utils/needLoginList";

export default {
  name: 'marketFrame',
  data() {
    return {
      // 左侧板块菜单
      plateList: [
        { canSee: true, name: '协议组件', iconSrc: require('@/assets/market/protocolAPP.png'), link: 'protocolApp' },
        { canSee: true, name: '逻辑组件', iconSrc: require('@/assets/market/logicAPP.png'), link: 'logicApp' },
        //{ canSee: true, name: '应用软件', iconSrc: require('@/assets/market/GMOSAPP.png'), link: 'appSoftware' },  // 旧的应用软件
        { canSee: true, name: '视图模板', iconSrc: require('@/assets/market/viewTemplate.png'), link: 'viewTemplate' },
        // { name: '全部', iconSrc: require('@/assets/market/商店_u61.svg'), link: 'allApp' }
        // { name: '应用软件发布', iconSrc: require('@/assets/market/u55.svg'), link: 'appPublish' },
        // { name: '订单信息', iconSrc: require('@/assets/market/u58.svg'), link: 'orderInfo' },
      ],
      // 左侧应用软件分类，动态获取
      // plateAppList: [
      //   // { name: '设备监控', iconSrc: require('@/assets/market/选型_u13.svg'), link: '/market/sortApp/1' },
      // ]
    }
  },
  methods: {
    // 动态获取左侧应用软件分类
    getPlateAppList() {
      selectApplystypeList().then(res => {
        if (res.returnCode === '100') {
          let dataArr = res.returnData
          let resArr = []
          for (let i = 0; i < dataArr.length; i++) {
            let item = {
              name: dataArr[i].applytypeName,
              iconSrc: require('@/assets/market/选型_u13.svg'),
              link: '/market/sortApp/' + dataArr[i].applytypeId
            }
            resArr.push(item)
          };
          this.plateAppList = resArr
        }
      }).catch(e => e)
    },
    // 根据权限展示左侧栏目及默认进入页面
    filterPlateList() {
      let suffix = '/market/';  // 用于匹配上routerAuthList
      // 根据权限判断是否展示
      for (let item of this.plateList) {
        if (hasAuthority(suffix + item.link)) {
          item.canSee = true;
        } else {
          item.canSee = false;
        }
      }
      // 根据展示情况找到默认展示
      for (let item of this.plateList) {
        if (item.canSee) {
          this.$router.push({ name: item.link });
          return;
        }
      }
    },
  },
  mounted() {
    // this.getPlateAppList()
    this.filterPlateList();
  }
}
</script>

<style scoped lang="less">
.asideContainer {
  height: 100%;
  padding: 0.5rem;

  .asideList {
    height: 100%;
    background-color: white;
    box-shadow: 4px 4px #f2f2f2;
    text-align: left;
  }
}

/*左侧菜单的选中样式*/
.asideItem {
  height: 54px;
  line-height: 54px;
  cursor: pointer;
}

.asideItem:hover {
  background-color: #f0f0f0;
}

.titleIcon {
  margin: 0 28px;
  display: inline-block;
}

.titleText {
  display: inline-block;
  font-size: 18px;
  vertical-align: baseline;
  color: #617799;
}

/*确保整个可点击区域都能进行路由跳转*/
.aCoverDiv {
  display: inline-block;
  width: 100%;
}

.router-link-active {
  .asideItem {
    background-color: #d2e6ff;

    .titleText {
      color: #1f65ff;
    }
  }

  .asideItem:hover {
    background-color: #d2e6ff;
  }
}
</style>
